import * as React from "react";
import { useSelector, RootStateOrAny } from "react-redux";
import BasicList from "../../common/layout/BasicList";

import {
  setAdmin,
  setSelectedAdmins,
  toggleAdminsPanel,
  reloadAdmins,
  addNewAdmin,
} from "../../../config/redux/admins/adminsActions";
import { adminsColumns } from "./adminsColumns";
import { getAdmins } from "../../../connectors/admins/connectors/index";
import { useTranslation } from 'react-i18next';

const AdminsList: React.FC = () => {
  const { t } = useTranslation('admin');
  const {
    selectedAdmins,
    activeAdmin,
    adminsPanelOpen,
    reloadAdminsList,
    addAdmin,
  } = useSelector((state: RootStateOrAny) => state.admins);

  const parseAdmin = (items: Array<any>) => {
    const admins = items.map((item: any) => item.userData);
    return admins;
  };

  return (
    <>
      <BasicList
        setSelectedItems={setSelectedAdmins}
        setActiveItem={setAdmin}
        togglePanel={toggleAdminsPanel}
        reload={reloadAdmins}
        editList={addNewAdmin}
        getData={getAdmins}
        activeItem={activeAdmin}
        panelOpen={adminsPanelOpen}
        selectedItems={selectedAdmins}
        removeItems={reloadAdminsList}
        listEdited={addAdmin}
        columns={adminsColumns(t)}
        parseItems={parseAdmin}
        
      />
    </>
  );
};

export default AdminsList;


